import { Component, Input } from '@angular/core';
import { IBreadCrumb } from './model/ibread-crumb';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './bread-crumb.component.html'
})
export class BreadcrumbComponent {
  @Input() breadcrumbItems: IBreadCrumb[];
  @Input() pageTitle: string = '';

}
